import { useEffect, useState } from "react";
import { toast } from "sonner";
import { admin, formatError } from "@/lib/growthApi";

const NAMES = { anthropic: "Claude Sonnet 5.5", openai: "ChatGPT GPT-5.5" };

export function ModelSwitch({ byModel }) {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { admin.modelSetting().then(setS).catch(() => {}); }, []);
  if (!s) return null;
  const choose = async (provider) => {
    if (provider === s.provider || busy) return;
    setBusy(true);
    try { const u = await admin.setModel(provider); setS({ ...s, ...u }); toast.success(`Adviser now using ${NAMES[provider]}`); }
    catch (e) { toast.error(formatError(e)); }
    finally { setBusy(false); }
  };
  return (
    <div className="mt-10" data-testid="admin-model-switch">
      <p className="eyebrow mb-5">Adviser AI model</p>
      <div className="divide-y divide-white/10 border-y border-white/10">
        {s.options.map((o) => {
          const on = o.provider === s.provider;
          return (
            <button key={o.provider} type="button" onClick={() => choose(o.provider)} disabled={busy} data-testid={`admin-model-option-${o.provider}`} aria-pressed={on}
              className={`flex w-full items-center justify-between gap-4 py-3.5 text-left transition-colors ${on ? "text-white" : "text-slate-400 hover:text-gold"}`}>
              <span>
                <span className="block text-sm font-semibold">{NAMES[o.provider]}</span>
                <span className="block font-mono text-[10px] uppercase tracking-[0.15em] text-slate-500">{o.model}{byModel ? ` · ${byModel[o.model] || 0} leads` : ""}</span>
              </span>
              <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${on ? "bg-gold shadow-[0_0_10px_rgba(212,175,55,0.7)]" : "border border-white/20"}`} />
            </button>
          );
        })}
      </div>
      <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.15em] text-slate-600" data-testid="admin-model-active">Active: {s.model}</p>
    </div>
  );
}
